import type { Cashier } from "@/services/sharedTypes/cashiers"
import api from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"
import { BASE_CASHIERS_QUERY_KEY } from "../queryKeys"

export const listCashiers = async (): Promise<
  Cashier[]
> => {
  const response = await api.get<Cashier[]>("/cashiers/")

  return response.body
}

export const useCashiers = () => {
  const { data, ...query } = useQuery(
    [BASE_CASHIERS_QUERY_KEY],
    () => listCashiers(),
    {
      staleTime: 60 * 60 * 1000,
    }
  )

  const getById = (
    id: MaybeRef<string | null | undefined>
  ) =>
    computed(() => {
      if (!unref(id)) return
      if (data.value === undefined) return

      return data.value.find(
        (cashier) => cashier.id === unref(id)
      )
    })

  const sortedCashiers = computed(() => {
    if (data.value === undefined) return []

    const cashiers = [...data.value]

    cashiers.sort((a, b) =>
      a.username < b.username
        ? -1
        : a.username > b.username
          ? 1
          : 0
    )

    return cashiers
  })

  return {
    data: sortedCashiers,
    getById,
    ...query,
  }
}
